import { useState } from "react";
import { detectOs } from "./platformDetect";

export function useDesktopPlatform() {
  const [platform] = useState(() =>
    typeof navigator === "undefined"
      ? "unknown"
      : detectOs(navigator.userAgent, navigator.maxTouchPoints),
  );
  return platform;
}
